'use client'

import {useState, useEffect} from 'react'
import {CanonicalHost, canonicalHost, extendedCanonicalHosts} from './constants'

export const useIsCanonicalHost = (): CanonicalHost => {
  const [hostInfo, setHostInfo] = useState<CanonicalHost>({
    isCanonical: false,
    isExtendedCanonical: false,
  })

  useEffect(() => {
    const host = window.location.hostname
    setHostInfo({
      isCanonical: host === canonicalHost,
      isExtendedCanonical: extendedCanonicalHosts.includes(host),
    })
  }, [])

  return hostInfo
}
